<div class="page-container">
  <div class="header-section">
    <lib-breadcrumb [list]="breadcrumbs()"></lib-breadcrumb>
    <h2 class="page-title">Judge Panel Assignment</h2>
  </div>

  <div class="content-wrapper" [class.blur]="loading">

    <form [formGroup]="searchFormGrp" (ngSubmit)="searchHandler()" class="search-form-card">
      <div class="search-grid">
        <div class="form-item">
          <mat-label class="required-label">Session</mat-label>
          <mat-form-field appearance="outline" class="full-width">
            <mat-select formControlName="sessionControl" (selectionChange)="onSessionChange($event.value)"
              [disabled]="isSearchComplete">
              <mat-option>
                <ngx-mat-select-search [formControl]="sessionFilterCtrl" placeholderLabel="Search..."
                  noEntriesFoundLabel="No results found">
                </ngx-mat-select-search>
              </mat-option>
              <mat-option *ngIf="isLoadingSession" disabled>
                <div style="display: flex; justify-content: center; align-items: center; width: 100%;">
                  <span>Loading sessions...</span>
                </div>
              </mat-option>
              <mat-option *ngFor="let session of filteredSessions | async" [value]="session">
                {{ session.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="form-item">
          <mat-label class="required-label">Panels</mat-label>
          <mat-form-field appearance="outline" class="full-width">
            <mat-select formControlName="panelControl" [disabled]="isSearchComplete">
              <mat-option>
                <ngx-mat-select-search [formControl]="panelsFilterCtrl" placeholderLabel="Search..."
                  noEntriesFoundLabel="No results found">
                </ngx-mat-select-search>
              </mat-option>
              <mat-option *ngIf="isLoadingPanel" disabled>
                <div style="display: flex; justify-content: center; align-items: center; width: 100%;">
                  <span>Loading panels...</span>
                </div>
              </mat-option>
              <mat-option *ngFor="let panel of filteredPanels | async" [value]="panel">
                {{ panel.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="form-actions">
          <button type="button" mat-stroked-button color="primary" (click)="resetHandler()">Reset</button>
          <button type="submit" mat-flat-button color="primary" [disabled]="isSearching || searchFormGrp.invalid">
            <span *ngIf="!isSearching">Search</span>
            <span *ngIf="isSearching">Searching...</span>
          </button>
        </div>
      </div>
    </form>

    <!-- Dual Listbox Section -->
    <div class="dual-listbox-section">

      <div class="section-container">
        <h3 class="heading section-title">Judge Panel Assignment</h3>
        <div class="section-header interactive-header">
          <div class="instruction-wrapper">
            <mat-icon color="primary" class="info-icon">info</mat-icon>
            <span class="instruction-text">Drag and drop to move judges between Available and Panel lists.</span>
          </div>

          <div class="action-toolbar">
            <div class="save-action animated-action" [class.disabled]="!hasChanges"
              (click)="hasChanges && saveAssignment()">
              <mat-icon>save</mat-icon>
              <span>Save</span>
            </div>
          </div>
        </div>
      </div>

      <div class="dual-listbox-container">

        <!-- Available Judges List -->
        <div class="listbox-panel">
          <div class="panel-header"
            style="display: flex; justify-content: space-between; align-items: center; padding: 6px 16px;">
            <span>Available Judges</span>
            <input type="text" placeholder="Search judges..."
              style="border-radius: 4px; border: none; padding: 4px 8px; font-size: 0.85rem; color: #333; width: 140px;"
              [formControl]="searchAvailableJudgesCtrl">
          </div>
          <div cdkDropList #availableList="cdkDropList" [cdkDropListData]="filteredAvailableJudges"
            [cdkDropListConnectedTo]="[panelList]" class="judge-list" (cdkDropListDropped)="drop($event)">

            <div class="judge-list-header">
              <span>Judge Name</span>
              <span>Judge ID</span>
            </div>

            <div class="judge-box box-state" *ngFor="let item of filteredAvailableJudges" cdkDrag>
              <span>{{item.justiceName}}</span>
              <span>{{item.justiceId}}</span>
            </div>

          </div>
        </div>

        <!-- Panel Judges List -->
        <div class="listbox-panel">
          <div class="panel-header">Panel Judges</div>
          <div cdkDropList id="panelList" #panelList="cdkDropList" [cdkDropListData]="panelJudges"
            [cdkDropListConnectedTo]="[availableList]" class="judge-list" (cdkDropListDropped)="drop($event)">

            <div class="judge-list-header">
              <span>Judge Name</span>
              <span>Judge ID</span>
            </div>

            <div class="judge-box" *ngFor="let item of panelJudges" cdkDrag>
              <span>{{item.justiceName}}</span>
              <span>{{item.justiceId}}</span>
            </div>

          </div>
        </div>

      </div>
    </div>
  </div>
</div>